import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboardStats,
  fetchCalendarAppointments,
} from "../thunks/cabinetDashboardThunks";

const today = new Date();
const pad = (n) => String(n).padStart(2, "0");
const toDateStr = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const initialState = {
  /* calendar UI */
  anchorDate: toDateStr(today),
  viewMode: "Day", // "Day" | "Week" | "Month"

  /* today's stats */
  stats: {
    appointments: 12,
    waiting: 3,
    completed: 8,
    revenue: 0,
    appointmentsDelta: "+2 from yesterday",
    completionRate: "67% completion",
    revenueDelta: "0% vs avg",
  },
  statsLoading: false,
  statsError: null,

  /* calendar appointments */
  calendarItems: [],
  calendarLoading: false,
  calendarError: null,
};

const cabinetDashboardSlice = createSlice({
  name: "cabinetDashboard",
  initialState,
  reducers: {
    setAnchorDate(state, action) {
      state.anchorDate = action.payload;
    },
    setViewMode(state, action) {
      state.viewMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    /* fetchDashboardStats */
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.statsLoading = true;
        state.statsError = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, { payload }) => {
        state.statsLoading = false;
        state.stats = { ...state.stats, ...payload };
      })
      .addCase(fetchDashboardStats.rejected, (state, { payload }) => {
        state.statsLoading = false;
        state.statsError = payload?.message ?? "Unknown error";
      });

    /* fetchCalendarAppointments */
    builder
      .addCase(fetchCalendarAppointments.pending, (state) => {
        state.calendarLoading = true;
        state.calendarError = null;
      })
      .addCase(fetchCalendarAppointments.fulfilled, (state, { payload }) => {
        state.calendarLoading = false;
        state.calendarItems = payload ?? [];
      })
      .addCase(fetchCalendarAppointments.rejected, (state, { payload }) => {
        state.calendarLoading = false;
        state.calendarError = payload?.message ?? "Unknown error";
      });
  },
});

export const { setAnchorDate, setViewMode } = cabinetDashboardSlice.actions;
export default cabinetDashboardSlice.reducer;
